var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "py-2 text-sm leading-5 text-gray-900 focus:outline-none",
      attrs: { contenteditable: "" },
      on: { blur: _vm.onEdit },
    },
    [_vm._v(" " + _vm._s(_vm.value) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }